import { forwardRef, type InputHTMLAttributes } from 'react';
import { cn } from '../../../lib/utils.js';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  hint?: string;
  error?: string;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ label, hint, error, className, id, ...props }, ref) => {
    const inputId = id ?? props.name;
    return (
      <div className="flex flex-col gap-1.5">
        {label && (
          <label htmlFor={inputId} className="text-[12px] font-medium text-n-700">
            {label}
          </label>
        )}
        <input
          ref={ref}
          id={inputId}
          className={cn(
            'h-[36px] rounded-md border border-n-200 bg-white px-3 text-[14px] text-n-900',
            'placeholder:text-n-400',
            'hover:border-n-300',
            'focus:border-brand-500 focus:outline-none',
            'disabled:bg-n-50 disabled:text-n-400',
            error && 'border-danger-500 focus:border-danger-500',
            className,
          )}
          {...props}
        />
        {error ? (
          <span className="text-[12px] text-danger-600">{error}</span>
        ) : hint ? (
          <span className="text-[12px] text-n-500">{hint}</span>
        ) : null}
      </div>
    );
  },
);
Input.displayName = 'Input';
